"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
export default function FeaturedPortfolio() {
  const videos = [{
    id: 1,
    thumbnail: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-15.54.51.png",
    title: "Instagram Reel - Ristosubito.com"
  }, {
    id: 2,
    thumbnail: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-15.54.36.png",
    title: "Instagram Reel - Ristosubito.com"
  }, {
    id: 3,
    thumbnail: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-16.27.19.png",
    title: "Video di presentazione CiakMediaLab"
  }];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground sm:text-5xl">
            I nostri progetti
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Scopri i nostri utlimi video sui social
          </p>
        </div>

        <div className="flex flex-col items-center gap-8">
          {videos.map((video, i) => <Link key={video.id} to="/PortfolioPage" className="group block w-full max-w-2xl focus-ring" data-index={i}>
              <Card className="overflow-hidden border-2 border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.02] hover:shadow-medium">
                <div className="relative aspect-video w-full overflow-hidden bg-muted">
                  <img src={video.thumbnail} alt={video.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                  
                  <div className="absolute inset-0 flex items-center justify-center bg-dark-background/40 transition-colors duration-[var(--duration-fast)] group-hover:bg-dark-background/50">
                    <div className="relative">
                      <div className="absolute inset-0 animate-ping rounded-full bg-primary/60" />
                      <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-primary shadow-strong transition-transform duration-[var(--duration-fast)] ease-[var(--ease-spring)] group-hover:scale-110 group-active:scale-95">
                        <Play className="h-10 w-10 fill-foreground-primary text-foreground-primary" />
                      </div>
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-dark-background/80 to-transparent p-6">
                    <h3 className="font-display text-xl font-semibold text-foreground-dark">
                      {video.title}
                    </h3>
                  </div>
                </div>
              </Card>
            </Link>)}
        </div>

        <div className="mt-12 text-center">
          <Link to="/PortfolioPage" className="btn-primary inline-flex items-center gap-2 text-lg">Vai ai nostri progetti<Play className="h-5 w-5" /></Link>
        </div>
      </div>
    </section>;
}